import { MainLayout } from '@/components';
import { ResponsiveContainer } from '@/styles';
import { Grid } from '@mui/material';
import React from 'react';
import PageMetaHead from 'src/logic/config/meta/PageMetaHead';
import useSetHeaderData from 'src/logic/hooks/use-header';
import useStickyState from 'src/logic/hooks/use-sticky-state';
import FormWithSummaryLayout from 'src/ui/components/dumb/procurement/product-form-manager/general-components/form-with-summary-layout';
import AdvancedFiltersResults from 'src/ui/components/smart/catalogue/advanced-filters/AdvancedFiltersResults';
import CatalogueContent from 'src/ui/components/smart/catalogue/catalogue-content/CatalogueContent';

const CatalogueIndexPage = () => {
  useSetHeaderData('Directory', null);
  const stickyRef = React.useRef<HTMLDivElement>(null);
  const isSticky = useStickyState(stickyRef);

  return (
    <Grid
      sx={{
        bgcolor: 'background.primary.main',
        width: '100%',
        minHeight: 'calc(100vh - 66px)',
      }}
      container
      component={ResponsiveContainer}
      gap={2}
    >
      <Grid
        container
        pb={5}
        mt={3}
        sx={{ maxWidth: '1400px', marginInline: 'auto', position: 'relative', flexDirection: 'column' }}
      >
        <div
          style={{
            width: '100%',
            top: '0',
            position: 'sticky',
            zIndex: 2,
          }}
          ref={stickyRef}
        >
          <div
            style={{
              width: '100%',
              boxShadow: isSticky
                ? '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
                : '14px 17px 40px 4px #7090B014',
              borderRadius: '8px',
              backgroundColor: '#fff',
              maxHeight: '95vh',
              overflow: 'auto',
            }}
            className='styled-scrollbar'
          >
            <CatalogueContent closeOnClickOutside />
          </div>
        </div>

        <div style={{ paddingTop: '1rem', width: '100%' }}>
          {/* Here goes the content */}
          <AdvancedFiltersResults />
        </div>
      </Grid>
    </Grid>
  );
};

CatalogueIndexPage.getLayout = function getLayout(page: React.ReactElement) {
  return (
    <MainLayout showAddNewPrivateItemLink>
      <PageMetaHead
        page_meta={{
          title: 'AI-Powered Procurement Catalog | Smart Automation for Sourcing',
          description:
            'Integrate supplier data with AI-powered procurement catalogs. Use smart search, real-time analytics, and catalog automation to simplify sourcing and speed up RFQs.',
          keywords:
            'AI procurement catalogue, intelligent catalog management, AI product catalog automation, smart procurement catalog, AI supplier catalog integration, automated RFQ catalog, real‑time catalog analytics, AI‑powered catalog search, machine learning catalog optimization, procurement catalog digital transformation',
        }}
        useExactTitle
      />
      <FormWithSummaryLayout>{page}</FormWithSummaryLayout>
    </MainLayout>
  );
};

export default CatalogueIndexPage;
